import { useFeatureIsOn } from '@growthbook/growthbook-react'
import { Select, Space, Tooltip } from 'antd'
import {
  Button,
  ButtonActionBar,
  CustomBottomAction,
  DropdownMenu,
  Typography,
} from 'modules/core/components'
import { generateSelectOptions } from 'modules/core/utils'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { SolutionOutlined, ShareAltOutlined } from '@ant-design/icons'

const UserActionsGlobalDetail = ({
  onClickPublish,
  disabledPublish,
  buttonPublishName,
  tooltipApprove,
  onClickApprove,
  disableApprove,
  buttonApproveName,
  onClickApply,
  extraButtons,
  defaultCurrency,
  currencyOptions,
  onChangeCurrency,
  onClickActivity,
  onClickCompartir,
}) => {
  const enabled = useFeatureIsOn('feature-moneda-seguimiento')
  const enableUrls = useFeatureIsOn('enable-urls')
  const { t } = useTranslation()
  return (
    <ButtonActionBar position="space-between">
      <Space direction="horizontal">
        {enabled && (
          <>
            <Typography.Body>{t('LABEL_CURRENCY')}:</Typography.Body>
            <Select
              bordered={false}
              value={defaultCurrency}
              placeholder={t('ACTION_SELECT')}
              options={generateSelectOptions({ options: currencyOptions })}
              onChange={onChangeCurrency}
            />
          </>
        )}
      </Space>
      <Space direction="horizontal">
        <Button.PrimaryGhost
          onClick={onClickPublish}
          disabled={disabledPublish}
          title={buttonPublishName}
        />
        <Tooltip title={tooltipApprove}>
          <Button.Primary
            onClick={onClickApprove}
            disabled={disableApprove}
            title={buttonApproveName}
          />
        </Tooltip>
        <Button.Default onClick={onClickApply} title="LABEL_TOOLS" />
        <CustomBottomAction extraButtons={extraButtons} />
        {enableUrls && (
          <Button.Icon
            title="ACTION_SHARE"
            icon={<Typography.Icon icon={ShareAltOutlined} />}
            onClick={onClickCompartir}
          />
        )}
        <DropdownMenu
          title={t('ACTION_MORE')}
          menu={[
            {
              title: t('ACTION_ACTIVITIES'),
              icon: <SolutionOutlined />,
              onClick: onClickActivity,
            },
          ]}
        />
      </Space>
    </ButtonActionBar>
  )
}

export default UserActionsGlobalDetail
